import { EntityHandler, EntityListResult, SectionHandlerGroup } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { IdNameType } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { RegisterEntityHandler } from '../../entities';
import { buildChartSectionGroup } from '../shared/chart.section';

@RegisterEntityHandler('system')
@Injectable()
export class SystemHandler extends EntityHandler<IdNameType> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    counts = ['distributor', 'vendor', 'client', 'asset', 'device', 'companion-camera', 'user'];

    listEntities(_ownerId: string, _offset: number, _limit: number, _sort: string, _filter: string): Promise<EntityListResult> {
        return Promise.resolve(null); // no system list
    }

    getEntity(_id: string): Promise<IdNameType> {
        return Promise.resolve({
            ownerId: '00000000-0000-0000-0000-000000000000',
            id: '00000000-0000-0000-0000-000000000000',
            name: 'System',
            type: 'system',
        });
    }

    getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        return Promise.resolve([]); // system has no list
    }

    async getEditorSections(_ownerId: string, _entity: any): Promise<SectionHandlerGroup<IdNameType>[]> {

        const sections = [
            buildChartSectionGroup(this.admin, 'system', this.counts, ['7d', '30d', '60d', '90d']),
        ];
        return sections;

    }

}











